export const widgetManagementStyles = {
  root: {},
  paper: {
    background: '#fff',
    border: '1px solid var(--color-border, #e5e7eb)',
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    padding: '20px',
    textAlign: 'center',
    minHeight: 400,
    height: 'auto',
  },
  sectionHeader: {
    padding: '10px 16px',
    background: '#f9fafb',
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 13,
    color: '#374151',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  combo: {
    marginBottom: 16,
  },
  row: {
    marginTop: 12,
    display: 'flex',
    alignItems: 'center',
  },
  filterTitle: {
    flexGrow: 1,
  },
  filterToggle: {
    margin: '0 12px',
  },
  label: {
    verticalAlign: 'middle',
    marginRight: '1em',
  },
  text: {
    marginTop: '1em',
  },
  gridColumn: {
    margin: '12px',
  },
  dataSourceLabel: {
    textAlign: 'left',
    marginTop: 12,
  },
  tableColumnPropertyRow: {
    marginTop: 12,
    display: 'flex',
    alignItems: 'center',
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
  },
  draggableFilter: {
    padding: 8,
    borderRadius: 8,
    border: '1px solid var(--color-border, #e5e7eb)',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },
  filterSection: {
    marginBottom: 16,
    borderRadius: 12,
    border: '1px solid var(--color-border, #e5e7eb)',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  },
  filterSectionHeader: {
    padding: 16,
    display: 'flex',
    alignItems: 'center',
  },
  filterSectionContent: {
    padding: '0 16px 8px',
  },
  dragIcon: {
    margin: '0 8px',
    color: '#9ca3af',
  },
};
